import { AxiosError } from 'axios';

import { USERS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { MyProfile } from '@/types/my-profile.type';
import { ApiResponse } from '@/types/response.type';

import {
  mapMyProfileResponseToMyProfile,
  mapSaveMyProfilePayloadToRequest,
  MyProfileResponse,
  SaveMyProfileApiPayload,
} from './shared';

const updateMyProfile = async (
  payload: SaveMyProfileApiPayload
): Promise<ApiResponse<MyProfile>> => {
  try {
    const response = await apiManager.patch<ApiResponse<MyProfileResponse>>(
      `${USERS_API_URL}/me/profile`,
      mapSaveMyProfilePayloadToRequest(payload),
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    if (!response.data.data) {
      return Promise.reject(new Error('Profile payload is missing'));
    }

    return Promise.resolve({
      ...response.data,
      data: mapMyProfileResponseToMyProfile(response.data.data),
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

export default updateMyProfile;
